module.exports = __webpack_public_path__ + "static/media/Перелесье гусь 2.47bd3f94.jpg";